import Excel from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";
import JSZip from "jszip";
import iconv from "iconv-lite";
import Helper from "../plugins/Helper/Helper"

export class ExportSAGE {
  static async exportReceipt(receipts, erpCode, callBackType) {
    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet("INV")
    worksheet.columns = Array(179).fill({}).map((data, index) => {
      return {
        key: index + 1,
        width: 15
      }
    });
    worksheet.addRow({
      1: "RECTYPE",
      2: "CODEPYMTYP",
      3: "CNTBTCH",
      4: "CNTITEM",
      5: "IDRMIT",
      6: "IDCUST",
      7: "DATERMIT",
      8: "TEXTRMIT",
      9: "TXTRMITREF",
      10: "AMTRMIT",
      11: "AMTRMITTC",
      12: "RATEEXCHTC",
      13: "SWRATETC",
      14: "CNTPAYMETR",
      15: "AMTPAYMTC",
      16: "AMTDISCTC",
      17: "CODEPAYM",
      18: "CODECURN",
      19: "RATETYPEHC",
      20: "RATEEXCHHC",
      21: "SWRATEHC",
      22: "RMITTYPE",
      23: "DOCTYPE",
      24: "IDINVCMTCH",
      25: "CNTLSTLINE",
      26: "FISCYR",
      27: "FISCPER",
      28: "TEXTPAYOR",
      29: "DATERATETC",
      30: "RATETYPETC",
      31: "AMTADJENT",
      32: "DATERATEHC",
      33: "PAYMTYPE",
      34: "REMUNAPLTC",
      35: "REMUNAPL",
      36: "AMTRMITHC",
      37: "DOCNBR",
      38: "AMTADJHC",
      39: "OPERBANK",
      40: "OPERCUST",
      41: "AMTDISCHC",
      42: "AMTDBADJHC",
      43: "AMTCRADJHC",
      44: "AMTDBADJTC",
      45: "AMTCRADJTC",
      46: "SWJOB",
      47: "APPLYMETH",
      48: "ERRBATCH",
      49: "ERRENTRY",
      50: "VALUES",
      51: "PROCESSCMD",
      52: "SRCEAPPL",
      53: "IDBANK",
      54: "CODECURNBC",
      55: "DRILLAPP",
      56: "DRILLTYPE",
      57: "DRILLDWNLK",
      58: "SWPRINTED",
      59: "SWTXAMTCTL",
      60: "CODETAXGRP",
      61: "TAXVERSION",
      62: "CODETAX1",
      63: "CODETAX2",
      64: "CODETAX3",
      65: "CODETAX4",
      66: "CODETAX5",
      67: "TAXCLASS1",
      68: "TAXCLASS2",
      69: "TAXCLASS3",
      70: "TAXCLASS4",
      71: "TAXCLASS5",
      72: "TXBSE1TC",
      73: "TXBSE2TC",
      74: "TXBSE3TC",
      75: "TXBSE4TC",
      76: "TXBSE5TC",
      77: "TXAMT1TC",
      78: "TXAMT2TC",
      79: "TXAMT3TC",
      80: "TXAMT4TC",
      81: "TXAMT5TC",
      82: "TXTOTTC",
      83: "AMTNETTC",
      84: "DEPSEQ",
      85: "DEPLINE",
      86: "CODECURNRC",
      87: "SWTXCTLRC",
      88: "RATERC",
      89: "RATETYPERC",
      90: "RATEDATERC",
      91: "RATEOPRC",
      92: "SWRATERC",
      93: "TXAMT1RC",
      94: "TXAMT2RC",
      95: "TXAMT3RC",
      96: "TXAMT4RC",
      97: "TXAMT5RC",
      98: "TXTOTRC",
      99: "CNTACC",
      100: "AMTACCTC",
      101: "AMTACCHC",
      102: "AMTPAYMHC",
      103: "REMUNAPLHC",
      104: "TXBSE1HC",
      105: "TXBSE2HC",
      106: "TXBSE3HC",
      107: "TXBSE4HC",
      108: "TXBSE5HC",
      109: "TXAMT1HC",
      110: "TXAMT2HC",
      111: "TXAMT3HC",
      112: "TXAMT4HC",
      113: "TXAMT5HC",
      114: "TXTOTHC",
      115: "AMTNETHC",
      116: "ARVERSION",
      117: "ENTEREDBY",
      118: "DATEBUS",
      119: "IDACCTSET",
      120: "CCPREVID",
      121: "CCPREVSTTS",
      122: "CCTRANID",
      123: "CCTRANSTTS",
      124: "PROCESSCOD",
    });
    worksheet.addRow({
      1: "RECTYPE",
      2: "CODEPAYM",
      3: "CNTBTCH",
      4: "CNTITEM",
      5: "CNTLINE",
      6: "DOCNBR",
      7: "TEXTDESC",
      8: "TEXTREF",
      9: "AMTACCTC",
      10: "AMTACCHC",
      11: "IDCUST",
    })
    worksheet.addRow({
      1: "RECTYPE",
      2: "CODEPAYM",
      3: "CNTBTCH",
      4: "CNTITEM",
      5: "CNTLINE",
      6: "IDDISTCODE",
      7: "IDACCT",
      8: "GLREF",
      9: "GLDESC",
      10: "TAXCLASS1",
      11: "TAXCLASS2",
      12: "TAXCLASS3",
      13: "TAXCLASS4",
      14: "TAXCLASS5",
      15: "SWTAXINCL1",
      16: "SWTAXINCL2",
      17: "SWTAXINCL3",
      18: "SWTAXINCL4",
      19: "SWTAXINCL5",
      20: "TXBSE1TC",
      21: "TXBSE2TC",
      22: "TXBSE3TC",
      23: "TXBSE4TC",
      24: "TXBSE5TC",
      25: "RATETAX1",
      26: "RATETAX2",
      27: "RATETAX3",
      28: "RATETAX4",
      29: "RATETAX5",
      30: "TXAMT1TC",
      31: "TXAMT2TC",
      32: "TXAMT3TC",
      33: "TXAMT4TC",
      34: "TXAMT5TC",
      35: "TXTOTTC",
      36: "AMTDISTTC",
      37: "AMTNETTC",
      38: "AMTDISTHC",
      39: "AMTNETHC",
      40: "AMTCOGS",
      41: "ALTBASETAX",
      42: "TXAMT1RC",
      43: "TXAMT2RC",
      44: "TXAMT3RC",
      45: "TXAMT4RC",
      46: "TXAMT5RC",
      47: "TXTOTRC",
      48: "TXBSE1HC",
      49: "TXBSE2HC",
      50: "TXBSE3HC",
      51: "TXBSE4HC",
      52: "TXBSE5HC",
      53: "TXAMT1HC",
      54: "TXAMT2HC",
      55: "TXAMT3HC",
      56: "TXAMT4HC",
      57: "TXAMT5HC",
      58: "TXTOTHC",
      59: "CONTRACT",
      60: "PROJECT",
      61: "CATEGORY",
      62: "RESOURCE",
      63: "COSTCLASS",
      64: "BILLDATE",
    });
    worksheet.addRow({
      1: "RECTYPE",
      2: "CODEPAYM",
      3: "CNTBTCH",
      4: "CNTITEM",
      5: "CNTLINE",
      6: "IDCUST",
      7: "IDINVC",
      8: "CNTPAYM",
      9: "TRXTYPE",
      10: "PYMTRESL",
      11: "AMTPAYM",
      12: "AMTERNDISC",
      13: "CNTLASTSEQ",
      14: "AMTADJTOT",
      15: "CNTADJ",
      16: "TEXTADJ",
      17: "GLREF",
      18: "IDPPD",
      19: "IDDOCMTCH",
      20: "CDAPPLYTO",
      21: "OBSPAYMAMT",
      22: "OBSDISCAMT",
      23: "OBSNETBAL",
      24: "PNDPAYTOT",
      25: "PNDDSCTOT",
      26: "PNDADJTOT",
      27: "AMTDBADJTC",
      28: "AMTCRADJTC",
      29: "DOCTYPE",
      30: "SWJOB",
      31: "AMTPAYMTOT",
      32: "AMTDISCTOT",
      33: "APPLYMETH",
      34: "RTGTOTDBTC",
      35: "RTGTOTCRTC",
      36: "RTGAMT",
      37: "RTGDATEDUE",
      38: "RTGTERMS",
      39: "SWRTGRATE",
      40: "PROCESSCMD",
      41: "UNAPLPAYM",
      42: "UNAPLDISC",
      43: "TRXTYPEID",
      44: "RMITTYPE",
      45: "SWRTG",
      46: "RTGBAL",
      47: "RTGAPPLYTO",
      48: "AMTADJNET",
      49: "EXCHRATEHC",
      50: "DATEINVC",
      51: "AMTPAYMHC",
      52: "AMTDISCHC",
      53: "AMTADJHC",
      54: "RTGAMTHC",
      55: "ARVERSION",
      56: "CODECURN",
    });
    worksheet.addRow({
      1: "RECTYPE",
      2: "CODEPAYM",
      3: "CNTBTCH",
      4: "CNTITEM",
      5: "CNTLINE",
      6: "CNTSEQ",
      7: "CODTRXTYPE",
      8: "AMTDIST",
      9: "IDDISTCODE",
      10: "IDACCT",
      11: "CONTRACT",
      12: "PROJECT",
      13: "CATEGORY",
      14: "RESOURCE",
      15: "TRANSNBR",
      16: "COSTCLASS",
      17: "AMTDISC",
      18: "AMTPAYM",
      19: "IDITEM",
      20: "UNITMEAS",
      21: "QTYINVC",
      22: "AMTCOST",
      23: "BILLDATE",
      24: "RTGAMT",
      25: "RTGDATEDUE",
      26: "SWRTG",
      27: "AMTDISTHC",
      28: "AMTDISCHC",
      29: "AMTPAYMHC",
      30: "RTGAMTHC",
      31: "TEXTDESC",
      32: "TEXTREF",
      33: "DOCLINE",
      34: "AMTDUETC",
    });
    worksheet.addRow({
      1: "RECTYPE",
      2: "CODEPAYM",
      3: "CNTBTCH",
      4: "CNTITEM",
      5: "OPTFIELD",
      6: "VALUE",
      7: "TYPE",
      8: "LENGTH",
      9: "DECIMALS",
      10: "ALLOWNULL",
      11: "VALIDATE",
      12: "SWSET",
      13: "VALINDEX",
      14: "VALIFTEXT",
      15: "VALIFMONEY",
      16: "VALIFNUM",
      17: "VALIFLONG",
      18: "VALIFBOOL",
      19: "VALIFDATE",
      20: "VALIFTIME",
      21: "FDESC",
      22: "VDESC",
    });
    for (let receipt of receipts) {

      let receiptIndex = 0
      let invoice = receipt.invoice || {}
      let documentIdTypes = []
      let categoryCount = 0
      let market = receipt.market

      let hashItems = {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: [],
      }

      if (invoice.documentId1) {
        documentIdTypes.push(1)
        hashItems[1] = receipt.items.filter(d => d.sellVatType == 1 && d.accountingProduct && !d.accountingProduct.isMeterMonth)
        if (hashItems[1].length) categoryCount++
      }
      if (invoice.documentId2) {
        documentIdTypes.push(2)
        hashItems[2] = receipt.items.filter(d => d.sellVatType == 2 && d.accountingProduct && !d.accountingProduct.isMeterMonth)
        if (hashItems[2].length) categoryCount++
      }
      if (invoice.documentId3) {
        documentIdTypes.push(3)
        hashItems[3] = receipt.items.filter(d => d.sellVatType == 3 && d.accountingProduct && !d.accountingProduct.isMeterMonth)
        if (hashItems[3].length) categoryCount++
      }
      if (invoice.documentId4) {
        documentIdTypes.push(4)
        hashItems[4] = receipt.items.filter(d => d.sellVatType == 1 && d.accountingProduct && d.accountingProduct.isMeterMonth)
        if (hashItems[4].length) categoryCount++
      }
      if (invoice.documentId5) {
        documentIdTypes.push(5)
        hashItems[5] = receipt.items.filter(d => d.sellVatType == 2 && d.accountingProduct && d.accountingProduct.isMeterMonth)
        if (hashItems[5].length) categoryCount++
      }
      if (invoice.documentId6) {
        documentIdTypes.push(6)
        hashItems[6] = receipt.items.filter(d => d.sellVatType == 3 && d.accountingProduct && d.accountingProduct.isMeterMonth)
        if (hashItems[6].length) categoryCount++
      }

      let allItems = [
        ...hashItems[1],
        ...hashItems[2],
        ...hashItems[3],
        ...hashItems[4],
        ...hashItems[5],
        ...hashItems[6],
      ]

      let total = {
        totalValue: Helper.round(allItems.reduce((a, b) => a + (b.totalValue || 0), 0)),
        totalNonVatValue: Helper.round(allItems.reduce((a, b) => a + (b.totalNonVatValue || 0), 0)),
        totalVatValue: Helper.round(allItems.reduce((a, b) => a + (b.totalVatValue || 0), 0)),
        totalWhtValue: Helper.round(allItems.reduce((a, b) => a + (b.totalWhtValue || 0), 0)),
      }

      let customerMarketId = ""
      if (invoice.contract) {
        customerMarketId = receipt.contract.customerMarketId
      } else if (invoice.booking) {
        customerMarketId = receipt.booking.documentId
      }

      if (documentIdTypes.length && allItems.length && total.totalValue) {
        receiptIndex += 1
        worksheet.addRow({
          1: 1,
          2: "CA",
          3: 49276,
          4: 1,
          5: receipt.documentId || "",
          6: customerMarketId || "",
          7: moment(receipt.date).format("YYYYMMDD"),
          8: "LENGTH",
          9: "DECIMALS",
          10: (total.totalValue - total.totalWhtValue) || 0,
          11: (total.totalValue - total.totalWhtValue) || 0,
          12: 1,
          13: 0,
          14: categoryCount,
          15: (total.totalValue - total.totalWhtValue) || 0,
          16: 0,
          17: "CASH",
          18: "THB",
          19: "SP",
          20: 1,
          21: 0,
          22: 1,
          23: 1,
          26: moment(receipt.date).format("YYYY"),
          27: 10,
          28: receipt.customerData.name || "",
          29: moment(receipt.date).format("YYYYMMDD"),
          30: "SP",
          31: (total.totalWhtValue * -1) || 0,
          32: moment(receipt.date).format("YYYYMMDD"),
          33: 1,
          34: 0,
          35: 0,
          36: (total.totalValue - total.totalWhtValue) || 0,
          38: (total.totalWhtValue * -1) || 0,
          39: 1,
          40: 1,
          41: 0,
          42: total.totalVatValue || 0,
          43: (total.totalVatValue * -1) || 0,
          44: total.totalVatValue || 0,
          45: (total.totalVatValue * -1) || 0,
          46: 0,
          47: 0,
          48: 0,
          49: 0,
          50: 1,
          51: 0,
          52: "AR",
          53: erpCode,
          54: "THB",
          56: 0,
          57: 0,
          58: 0,
          59: 1,
          61: 0,
          67: 0,
          68: 0,
          69: 0,
          70: 0,
          71: 0,
          72: 0,
          73: 0,
          74: 0,
          75: 0,
          76: 0,
          77: 0,
          78: 0,
          79: 0,
          80: 0,
          81: 0,
          82: 0,
          83: 0,
          84: 1951,
          85: receiptIndex,
          87: 1,
          88: 1,
          91: 1,
          92: 0,
          93: 0,
          94: 0,
          95: 0,
          96: 0,
          97: 0,
          98: 0,
          99: 0,
          100: 0,
          101: 0,
          102: total.totalValue || 0,
          103: 0,
          104: 0,
          105: 0,
          106: 0,
          107: 0,
          108: 0,
          109: 0,
          110: 0,
          111: 0,
          112: 0,
          113: 0,
          114: 0,
          115: 0,
          116: "61A",
          117: "SRIPAI",
          118: moment(receipt.date).format("YYYYMMDD"),
          119: "MAK",
          121: 0,
          123: 0,
        });
        let lineOrder = 0
        for (let documentIdType of documentIdTypes) {
          if (hashItems[documentIdType].length) {
            lineOrder += 20
            let documentId;
            let invoiceDate = invoice.date

            if (documentIdType == 4 || documentIdType == 5 || documentIdType == 6) {
              invoiceDate = moment(invoice.date).subtract(1, 'months').endOf("month").toDate()
            }

            if (documentIdType == 1) {
              documentId = invoice.documentId1
            } else if (documentIdType == 2) {
              documentId = invoice.documentId2
            } else if (documentIdType == 3) {
              documentId = invoice.documentId3
            } else if (documentIdType == 4) {
              documentId = invoice.documentId4
            } else if (documentIdType == 5) {
              documentId = invoice.documentId5
            } else if (documentIdType == 6) {
              documentId = invoice.documentId6
            }

            let documentIdTypeTotal = {
              totalValue: Helper.round(hashItems[documentIdType].reduce((a, b) => a + (b.totalValue || 0), 0)),
              totalNonVatValue: Helper.round(hashItems[documentIdType].reduce((a, b) => a + (b.totalNonVatValue || 0), 0)),
              totalVatValue: Helper.round(hashItems[documentIdType].reduce((a, b) => a + (b.totalVatValue || 0), 0)),
              totalWhtValue: Helper.round(hashItems[documentIdType].reduce((a, b) => a + (b.totalWhtValue || 0), 0)),
            }

            if (documentIdTypeTotal.totalValue && hashItems[documentIdType].length && documentId) {
              if (documentIdType == 1 || documentIdType == 4) {
                worksheet.addRow({
                  1: 4,
                  2: "CA",
                  3: 49276,
                  4: receiptIndex,
                  5: lineOrder,
                  6: customerMarketId || "",
                  7: documentId || "",
                  8: 1,
                  9: 51,
                  10: 3,
                  11: (documentIdTypeTotal.totalValue - documentIdTypeTotal.totalWhtValue) || 0,
                  12: 0,
                  13: 3,
                  14: (documentIdTypeTotal.totalWhtValue * -1) || 0,
                  // 15: "--",
                  17: moment(receipt.date).format("YYYYMMDD"),
                  20: 1,
                  21: documentIdTypeTotal.totalValue || 0,
                  22: 0,
                  23: 0,
                  24: 0,
                  25: 0,
                  26: 0,
                  27: documentIdTypeTotal.totalWhtValue || 0,
                  28: (documentIdTypeTotal.totalVatValue * -1) || 0,
                  29: 1,
                  30: 0,
                  31: 0,
                  32: 0,
                  33: 0,
                  34: 0,
                  35: 0,
                  36: 0,
                  39: 0,
                  40: 0,
                  41: (documentIdTypeTotal.totalValue - documentIdTypeTotal.totalWhtValue) || 0,
                  42: 0,
                  43: 15,
                  44: 1,
                  45: 0,
                  46: 0,
                  48: (documentIdTypeTotal.totalWhtValue * -1) || 0,
                  49: 1,
                  50: moment(invoiceDate).format("YYYYMMDD"),
                  51: (documentIdTypeTotal.totalValue - documentIdTypeTotal.totalWhtValue) || 0,
                  52: 0,
                  53: (documentIdTypeTotal.totalWhtValue * -1) || 0,
                  54: 0,
                  55: "61A",
                  56: "THB",
                });
                worksheet.addRow({
                  1: 5,
                  2: "CA",
                  3: 49276,
                  4: receiptIndex,
                  5: lineOrder,
                  6: 1,
                  7: 81,
                  8: (documentIdTypeTotal.totalVatValue * -1) || 0,
                  10: market && (market.companyCode == "TTLPF" || market.companyCode == "CSL") ? "215220103" : "215220101",
                  15: 0,
                  16: 0,
                  17: 0,
                  18: 0,
                  21: 0,
                  22: 0,
                  24: 0,
                  26: 0,
                  27: (documentIdTypeTotal.totalVatValue * -1) || 0,
                  28: 0,
                  29: 0,
                  30: 0,
                  32: documentIdTypeTotal.totalNonVatValue || 0,
                  33: 0,
                  34: 0,
                });
                worksheet.addRow({
                  1: 5,
                  2: "CA",
                  3: 49276,
                  4: receiptIndex,
                  5: lineOrder,
                  6: 2,
                  7: 81,
                  8: documentIdTypeTotal.totalVatValue || 0,
                  10: market && (market.companyCode == "TTLPF" || market.companyCode == "CSL") ? "215220203" : "215220201",
                  15: 0,
                  16: 0,
                  17: 0,
                  18: 0,
                  21: 0,
                  22: 0,
                  24: 0,
                  26: 0,
                  27: documentIdTypeTotal.totalVatValue || 0,
                  28: 0,
                  29: 0,
                  30: 0,
                  32: documentIdTypeTotal.totalNonVatValue || 0,
                  33: 0,
                  34: 0,
                });
              }
              if (documentIdType == 2 || documentIdType == 3 || documentIdType == 5 || documentIdType == 6) {
                worksheet.addRow({
                  1: 4,
                  2: "CA",
                  3: 49276,
                  4: receiptIndex,
                  5: lineOrder,
                  6: customerMarketId || "",
                  7: documentId || "",
                  8: 1,
                  9: 51,
                  10: 3,
                  11: (documentIdTypeTotal.totalValue - documentIdTypeTotal.totalWhtValue) || 0,
                  12: 0,
                  13: 1,
                  14: (documentIdTypeTotal.totalWhtValue * -1) || 0,
                  15: 0,
                  20: 1,
                  21: documentIdTypeTotal.totalValue || 0,
                  22: 0,
                  23: 0,
                  24: 0,
                  25: 0,
                  26: 0,
                  27: documentIdTypeTotal.totalWhtValue || 0,
                  28: 0,
                  29: 1,
                  30: 0,
                  31: 0,
                  32: 0,
                  33: 0,
                  34: 0,
                  35: 0,
                  36: 0,
                  39: 0,
                  40: 0,
                  41: (documentIdTypeTotal.totalValue - documentIdTypeTotal.totalWhtValue) || 0,
                  42: 0,
                  43: 15,
                  44: 1,
                  45: 0,
                  46: 0,
                  48: (documentIdTypeTotal.totalWhtValue * -1) || 0,
                  49: 1,
                  50: moment(invoiceDate).format("YYYYMMDD"),
                  51: (documentIdTypeTotal.totalValue - documentIdTypeTotal.totalWhtValue) || 0,
                  52: 0,
                  53: (documentIdTypeTotal.totalWhtValue * -1) || 0,
                  54: 0,
                  55: "61A",
                  56: "THB",
                });
              }
              if (documentIdTypeTotal.totalWhtValue) {
                worksheet.addRow({
                  1: 5,
                  2: "CA",
                  3: 49276,
                  4: receiptIndex,
                  5: lineOrder,
                  6: 1,
                  7: 81,
                  8: documentIdTypeTotal.totalWhtValue || 0,
                  10: "115430001",
                  15: 0,
                  16: 0,
                  17: 0,
                  18: 0,
                  21: 0,
                  22: 0,
                  24: 0,
                  26: 0,
                  27: documentIdTypeTotal.totalWhtValue || 0,
                  28: 0,
                  29: 0,
                  30: 0,
                  33: 0,
                  34: 0,
                });
              }
            }
          }
        }
        worksheet.addRow({
          1: 6,
          2: "CA",
          3: 49276,
          4: receiptIndex,
          5: "COSTCENTER",
          6: "0000000",
          7: 1,
          8: 60,
          9: 0,
          10: 0,
          11: -1,
          12: 1,
          13: 21,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          20: "00:00:00",
          21: "หน่วยต้นทุน",
        });
      }
    }
    if (callBackType == "buffer") {
      // Thai Windows Char set
      let buf = await workbook.csv.writeBuffer();
      return iconv.encode(buf.toString("utf8") + "\n", 'win874');

      // UTF-8 Char set
      // return workbook.csv.writeBuffer()
    } else {
      // Thai Windows Char set
      let buf = await workbook.csv.writeBuffer();
      let win874Buf = iconv.encode(buf.toString("utf8") + "\n", 'win874');

      const blob = new Blob([win874Buf], { type: "text/csv" });
      return saveAs(blob, "sage-receipt-" + moment().format("DDMMYY") + ".csv");
    }
  }
  static async exportInvoice(invoices, callBackType) {
    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet("INV")
    worksheet.columns = Array(179).fill({}).map((data, index) => {
      return {
        key: index + 1,
        width: 15
      }
    });

    worksheet.addRow({
      1: "RECTYPE",
      2: "CNTBTCH",
      3: "CNTITEM",
      4: "IDCUST",
      5: "IDINVC",
      6: "IDSHPT",
      7: "SPECINST",
      8: "TEXTTRX",
      9: "IDTRX",
      10: "ORDRNBR",
      11: "CUSTPO",
      12: "INVCDESC",
      13: "SWPRTINVC",
      14: "INVCAPPLTO",
      15: "IDACCTSET",
      16: "DATEINVC",
      17: "DATEASOF",
      18: "FISCYR",
      19: "FISCPER",
      20: "CODECURN",
      21: "RATETYPE",
      22: "SWMANRTE",
      23: "EXCHRATEHC",
      24: "ORIGRATEHC",
      25: "TERMCODE",
      26: "SWTERMOVRD",
      27: "DATEDUE",
      28: "DATEDISC",
      29: "PCTDISC",
      30: "AMTDISCAVL",
      31: "LASTLINE",
      32: "CODESLSP1",
      33: "CODESLSP2",
      34: "CODESLSP3",
      35: "CODESLSP4",
      36: "CODESLSP5",
      37: "PCTSASPLT1",
      38: "PCTSASPLT2",
      39: "PCTSASPLT3",
      40: "PCTSASPLT4",
      41: "PCTSASPLT5",
      42: "SWTAXBL",
      43: "SWMANTX",
      44: "CODETAXGRP",
      45: "CODETAX1",
      46: "CODETAX2",
      47: "CODETAX3",
      48: "CODETAX4",
      49: "CODETAX5",
      50: "TAXSTTS1",
      51: "TAXSTTS2",
      52: "TAXSTTS3",
      53: "TAXSTTS4",
      54: "TAXSTTS5",
      55: "BASETAX1",
      56: "BASETAX2",
      57: "BASETAX3",
      58: "BASETAX4",
      59: "BASETAX5",
      60: "AMTTAX1",
      61: "AMTTAX2",
      62: "AMTTAX3",
      63: "AMTTAX4",
      64: "AMTTAX5",
      65: "AMTTXBL",
      66: "AMTNOTTXBL",
      67: "AMTTAXTOT",
      68: "AMTINVCTOT",
      69: "AMTPPD",
      70: "AMTPAYMTOT",
      71: "AMTPYMSCHD",
      72: "AMTNETTOT",
      73: "IDSTDINVC",
      74: "DATEPRCS",
      75: "IDPPD",
      76: "IDBILL",
      77: "SHPTOLOC",
      78: "SHPTOSTE1",
      79: "SHPTOSTE2",
      80: "SHPTOSTE3",
      81: "SHPTOSTE4",
      82: "SHPTOCITY",
      83: "SHPTOSTTE",
      84: "SHPTOPOST",
      85: "SHPTOCTRY",
      86: "SHPTOCTAC",
      87: "SHPTOPHON",
      88: "SHPTOFAX",
      89: "DATERATE",
      90: "SWPROCPPD",
      91: "AMTDUE",
      92: "CUROPER",
      93: "DRILLAPP",
      94: "DRILLTYPE",
      95: "DRILLDWNLK",
      96: "GETIBSINFO",
      97: "PROCESSCMD",
      98: "SHPVIACODE",
      99: "SHPVIADESC",
      100: "PRPTYCODE",
      101: "PRPTYVALUE",
      102: "SWJOB",
      103: "ERRBATCH",
      104: "ERRENTRY",
      105: "EMAIL",
      106: "CTACPHONE",
      107: "CTACFAX",
      108: "CTACEMAIL",
      109: "AMTDSBWTAX",
      110: "AMTDSBNTAX",
      111: "AMTDSCBASE",
      112: "INVCTYPE",
      113: "SWRTGINVC",
      114: "RTGAPPLYTO",
      115: "SWRTG",
      116: "RTGAMT",
      117: "RTGPERCENT",
      118: "RTGDAYS",
      119: "RTGDATEDUE",
      120: "RTGTERMS",
      121: "SWRTGDDTOV",
      122: "SWRTGAMTOV",
      123: "SWRTGRATE",
      124: "VALUES",
      125: "SRCEAPPL",
      126: "ARVERSION",
      127: "TAXVERSION",
      128: "SWTXRTGRPT",
      129: "CODECURNRC",
      130: "SWTXCTLRC",
      131: "RATERC",
      132: "RATETYPERC",
      133: "RATEDATERC",
      134: "RATEOPRC",
      135: "SWRATERC",
      136: "TXAMT1RC",
      137: "TXAMT2RC",
      138: "TXAMT3RC",
      139: "TXAMT4RC",
      140: "TXAMT5RC",
      141: "TXTOTRC",
      142: "TXBSERT1TC",
      143: "TXBSERT2TC",
      144: "TXBSERT3TC",
      145: "TXBSERT4TC",
      146: "TXBSERT5TC",
      147: "TXAMTRT1TC",
      148: "TXAMTRT2TC",
      149: "TXAMTRT3TC",
      150: "TXAMTRT4TC",
      151: "TXAMTRT5TC",
      152: "TXBSE1HC",
      153: "TXBSE2HC",
      154: "TXBSE3HC",
      155: "TXBSE4HC",
      156: "TXBSE5HC",
      157: "TXAMT1HC",
      158: "TXAMT2HC",
      159: "TXAMT3HC",
      160: "TXAMT4HC",
      161: "TXAMT5HC",
      162: "AMTGROSHC",
      163: "RTGAMTHC",
      164: "AMTDISCHC",
      165: "DISTNETHC",
      166: "AMTPPDHC",
      167: "AMTDUEHC",
      168: "SWPRTLBL",
      169: "TXTOTRTTC",
      170: "TXTOTAMT1",
      171: "TXTOTAMT2",
      172: "TXTOTAMT3",
      173: "TXTOTAMT4",
      174: "TXTOTAMT5",
      175: "RTGAMTDTL",
      176: "IDSHIaPNBR",
      177: "SWOECOST",
      178: "ENTEREDBY",
      179: "DATEBUS",
    });
    worksheet.addRow({
      1: "RECTYPE",
      2: "CNTBTCH",
      3: "CNTITEM",
      4: "CNTLINE",
      5: "IDITEM",
      6: "IDDIST",
      7: "TEXTDESC",
      8: "UNITMEAS",
      9: "QTYINVC",
      10: "AMTCOST",
      11: "AMTPRIC",
      12: "AMTEXTN",
      13: "AMTCOGS",
      14: "AMTTXBL",
      15: "TOTTAX",
      16: "BASETAX1",
      17: "BASETAX2",
      18: "BASETAX3",
      19: "BASETAX4",
      20: "BASETAX5",
      21: "TAXSTTS1",
      22: "TAXSTTS2",
      23: "TAXSTTS3",
      24: "TAXSTTS4",
      25: "TAXSTTS5",
      26: "SWTAXINCL1",
      27: "SWTAXINCL2",
      28: "SWTAXINCL3",
      29: "SWTAXINCL4",
      30: "SWTAXINCL5",
      31: "RATETAX1",
      32: "RATETAX2",
      33: "RATETAX3",
      34: "RATETAX4",
      35: "RATETAX5",
      36: "AMTTAX1",
      37: "AMTTAX2",
      38: "AMTTAX3",
      39: "AMTTAX4",
      40: "AMTTAX5",
      41: "IDACCTREV",
      42: "IDACCTINV",
      43: "IDACCTCOGS",
      44: "COMMENT",
      45: "SWPRTSTMT",
      46: "ITEMCOST",
      47: "CONTRACT",
      48: "PROJECT",
      49: "CATEGORY",
      50: "RESOURCE",
      51: "TRANSNBR",
      52: "COSTCLASS",
      53: "BILLDATE",
      54: "SWIBT",
      55: "SWDISCABL",
      56: "OCNTLINE",
      57: "RTGAMT",
      58: "RTGPERCENT",
      59: "RTGDAYS",
      60: "RTGDATEDUE",
      61: "SWRTGDDTOV",
      62: "SWRTGAMTOV",
      63: "VALUES",
      64: "PROCESSCMD",
      65: "RTGDISTTC",
      66: "RTGCOGSTC",
      67: "RTGALTBTC",
      68: "RTGINVDIST",
      69: "RTGINVCOGS",
      70: "RTGINVALTB",
      71: "TXAMT1RC",
      72: "TXAMT2RC",
      73: "TXAMT3RC",
      74: "TXAMT4RC",
      75: "TXAMT5RC",
      76: "TXTOTRC",
      77: "TXBSERT1TC",
      78: "TXBSERT2TC",
      79: "TXBSERT3TC",
      80: "TXBSERT4TC",
      81: "TXBSERT5TC",
      82: "TXAMTRT1TC",
      83: "TXAMTRT2TC",
      84: "TXAMTRT3TC",
      85: "TXAMTRT4TC",
      86: "TXAMTRT5TC",
      87: "TXBSE1HC",
      88: "TXBSE2HC",
      89: "TXBSE3HC",
      90: "TXBSE4HC",
      91: "TXBSE5HC",
      92: "TXAMT1HC",
      93: "TXAMT2HC",
      94: "TXAMT3HC",
      95: "TXAMT4HC",
      96: "TXAMT5HC",
      97: "TXAMTRT1HC",
      98: "TXAMTRT2HC",
      99: "TXAMTRT3HC",
      100: "TXAMTRT4HC",
      101: "TXAMTRT5HC",
      102: "DISTNETHC",
      103: "RTGAMTHC",
      104: "AMTCOGSHC",
      105: "AMTCOSTHC",
      106: "AMTPRICHC",
      107: "AMTEXTNHC",
      108: "TXTOTRTTC",
      109: "TXTOTAMT1",
      110: "TXTOTAMT2",
      111: "TXTOTAMT3",
      112: "TXTOTAMT4",
      113: "TXTOTAMT5",
      114: "RTGAMTOTC",
      115: "RTGDISTOTC",
      116: "RTGCOGSOTC",
      117: "RTGALTBOTC",
    });
    worksheet.addRow({
      1: "RECTYPE",
      2: "CNTBTCH",
      3: "CNTITEM",
      4: "CNTPAYM",
      5: "DATEDUE",
      6: "AMTDUE",
      7: "DATEDISC",
      8: "AMTDISC",
      9: "AMTDUEHC",
      10: "AMTDISCHC",
    });
    worksheet.addRow({
      1: "RECTYPE",
      2: "CNTBTCH",
      3: "CNTITEM",
      4: "OPTFIELD",
      5: "VALUE",
      6: "TYPE",
      7: "LENGTH",
      8: "DECIMALS",
      9: "ALLOWNULL",
      10: "VALIDATE",
      11: "SWSET",
      12: "VALINDEX",
      13: "VALIFTEXT",
      14: "VALIFMONEY",
      15: "VALIFNUM",
      16: "VALIFLONG",
      17: "VALIFBOOL",
      18: "VALIFDATE",
      19: "VALIFTIME",
      20: "FDESC",
      21: "VDESC",
    });
    worksheet.addRow({
      1: "RECTYPE",
      2: "CNTBTCH",
      3: "CNTITEM",
      4: "CNTLINE",
      5: "OPTFIELD",
      6: "VALUE",
      7: "TYPE",
      8: "LENGTH",
      9: "DECIMALS",
      10: "ALLOWNULL",
      11: "VALIDATE",
      12: "SWSET",
      13: "VALINDEX",
      14: "VALIFTEXT",
      15: "VALIFMONEY",
      16: "VALIFNUM",
      17: "VALIFLONG",
      18: "VALIFBOOL",
      19: "VALIFDATE",
      20: "VALIFTIME",
      21: "FDESC",
      22: "VDESC",
    });
    let index = 0

    for (let invoice of invoices) {
      for (let item of invoice.items) {
        if (item.accountingProduct) {
          if (item.accountingProduct.isRecurring) {
            item.accountingProduct.tempDistCode = item.accountingProduct.recurringDistCode
            item.accountingProduct.tempCode = item.accountingProduct.recurringCode
            item.accountingProduct.tempCode2 = item.accountingProduct.recurringCode2
            item.accountingProduct.tempCode3 = item.accountingProduct.recurringCode3
          } else {
            item.accountingProduct.tempDistCode = item.accountingProduct.distCode
            item.accountingProduct.tempCode = item.accountingProduct.code
            item.accountingProduct.tempCode2 = item.accountingProduct.code2
            item.accountingProduct.tempCode3 = item.accountingProduct.code3
          }
        }
      }

      for (let accountingProductIsMeterMonth of [1, 2]) {
        let _items = []
        let invoiceDate = invoice.date

        if (accountingProductIsMeterMonth == 1) {
          _items = invoice.items.filter(d => d.accountingProduct && !d.accountingProduct.isMeterMonth) // isMeterMonth == false
        } else {
          _items = invoice.items.filter(d => d.accountingProduct && d.accountingProduct.isMeterMonth) // isMeterMonth == true
          invoiceDate = moment(invoice.date).subtract(1, 'months').endOf("month").toDate()
        }

        for (let sellVatType of [1, 2, 3]) {
          let sellVatTypeDocumentId;
          let codeTax1;
          let codeTax2;
          let items = []
          if (accountingProductIsMeterMonth == 1) {
            if (sellVatType == 1) {
              sellVatTypeDocumentId = invoice.documentId1
              codeTax1 = "TAXS7"
              codeTax2 = "VATS"
            } else if (sellVatType == 2) {
              sellVatTypeDocumentId = invoice.documentId2
              codeTax1 = "TAX0"
              codeTax2 = "VAT0"
            } else if (sellVatType == 3) {
              sellVatTypeDocumentId = invoice.documentId3
              codeTax1 = "TAXX"
              codeTax2 = "VATX"
            }
          } else {
            if (sellVatType == 1) {
              sellVatTypeDocumentId = invoice.documentId4
              codeTax1 = "TAXS7"
              codeTax2 = "VATS"
            } else if (sellVatType == 2) {
              sellVatTypeDocumentId = invoice.documentId5
              codeTax1 = "TAX0"
              codeTax2 = "VAT0"
            } else if (sellVatType == 3) {
              sellVatTypeDocumentId = invoice.documentId6
              codeTax1 = "TAXX"
              codeTax2 = "VATX"
            }
          }
          items = _items.filter(d => d.sellVatType == sellVatType)

          if (items && items.length && sellVatTypeDocumentId) {
            index += 1
            let total = {
              totalValue: Helper.round(items.reduce((a, b) => a + (b.totalValue || 0), 0)),
              totalNonVatValue: Helper.round(items.reduce((a, b) => a + (b.totalNonVatValue || 0), 0)),
              totalVatValue: Helper.round(items.reduce((a, b) => a + (b.totalVatValue || 0), 0)),
            }

            let customerMarketId = ""
            let contractId = ""
            if (invoice.contract) {
              customerMarketId = invoice.contract.customerMarketId
              contractId = invoice.contract.contractId
            } else if (invoice.booking) {
              customerMarketId = invoice.booking.documentId
              contractId = invoice.booking.documentId
            }

            worksheet.addRow({
              1: 1,
              2: "18497",
              3: index,
              4: customerMarketId || "",
              5: sellVatTypeDocumentId,
              8: 1,
              9: 15,
              10: "",
              11: contractId || "",
              12: "ค่าเช่ารายเดือน",
              13: 0,
              15: "MAK",
              16: moment(invoiceDate).format("YYYYMMDD"),
              17: moment(invoiceDate).format("YYYYMMDD"),
              18: moment(invoiceDate).format("YYYY"),
              19: 12,
              20: "THB",
              21: "SP",
              22: 0,
              23: 1,
              24: 0,
              25: "N14",
              26: 0,
              27: moment(invoice.dueDate).format("YYYYMMDD"),
              29: 0,
              30: 0,
              31: 4,
              37: 0,
              38: 0,
              39: 0,
              40: 0,
              41: 0,
              42: 1,
              43: 0,
              44: codeTax1,
              45: codeTax2,
              50: 1,
              51: 0,
              52: 0,
              53: 0,
              54: 0,
              55: total.totalNonVatValue || 0,
              56: 0,
              57: 0,
              58: 0,
              59: 0,
              60: total.totalVatValue || 0,
              61: 0,
              62: 0,
              63: 0,
              64: 0,
              65: total.totalNonVatValue || 0,
              66: 0,
              67: total.totalVatValue || 0,
              68: total.totalNonVatValue || 0,
              69: 0,
              70: 1,
              71: total.totalValue || 0,
              72: total.totalValue || 0,
              89: moment(invoiceDate).format("YYYYMMDD"),
              90: 0,
              91: total.totalValue || 0,
              94: 0,
              95: 0,
              96: 0,
              97: 0,
              100: 1,
              101: 1,
              102: 0,
              103: 0,
              104: 0,
              109: total.totalValue || 0,
              110: total.totalNonVatValue || 0,
              111: 0,
              112: 1,
              113: 0,
              115: 0,
              116: 0,
              117: 0,
              118: 0,
              121: 0,
              122: 0,
              123: 0,
              124: 5,
              125: "AR",
              126: "61A",
              127: 1,
              128: 0,
              129: "THB",
              130: 1,
              131: 1,
              134: 1,
              135: 0,
              136: total.totalVatValue || 0,
              137: 0,
              138: 0,
              139: 0,
              140: 0,
              141: total.totalVatValue || 0,
              142: 0,
              143: 0,
              144: 0,
              145: 0,
              146: 0,
              147: 0,
              148: 0,
              149: 0,
              150: 0,
              151: 0,
              152: total.totalNonVatValue || 0,
              153: 0,
              154: 0,
              155: 0,
              156: 0,
              157: total.totalVatValue || 0,
              158: 0,
              159: 0,
              160: 0,
              162: total.totalValue || 0,
              163: 0,
              164: 0,
              165: total.totalNonVatValue || 0,
              166: 0,
              167: 11,
              168: 0,
              169: 0,
              170: total.totalVatValue || 0,
              171: 0,
              172: 0,
              173: 0,
              174: 0,
              175: 0,
              177: 0,
              179: moment(invoiceDate).format("YYYYMMDD"),
            });

            for (let item of items) {
              let accountingProduct = item.accountingProduct
              let area = item.area
              let code;

              if (accountingProduct) {
                if (accountingProduct.itemCode) {
                  code = accountingProduct.itemCode || ""
                } else {
                  code = `${area.name}-${accountingProduct.tempCode ? accountingProduct.tempCode.slice(0, 6) : ''}`
                }
              }

              item = {
                ...item,
                totalOriginalValue: item.totalOriginalValue,
                totalValue: item.totalValue,
                totalNonVatValue: item.totalNonVatValue,
                totalVatValue: item.totalVatValue,
                area,
              }

              let areaMeterName = ""
              if (area) {
                areaMeterName = area.name
                if (item.meter) {
                  areaMeterName += ";"
                  if (item.meter.name) {
                    areaMeterName += item.meter.name
                  }
                }
              }

              let buCode = invoice.market.buCode
              if (invoice.market.objectId == "xlQF920kvv") buCode = "9401021"
              if (invoice.market.objectId == "AC5WImaWqJ") buCode = "9401010"
              if (invoice.market.objectId == "CG4dYjHNwc") buCode = "6108001"
              
              worksheet.addRow({
                1: 2,
                2: "18497",
                3: index,
                4: 20,
                5: code, // "รหัสแผง+รหัสบัญชี",
                6: accountingProduct.tempDistCode || "",
                7: item.name + (item.detail ? ` ${item.detail}` : ""),
                8: accountingProduct.unitCode || "", // unit from acc product 
                9: item.quantity || 0,
                10: 0,
                11: item.originalPricePerUnit || 0,
                12: item.totalValue || 0,
                13: 0,
                14: item.totalNonVatValue || 0,
                15: item.totalVatValue || 0,
                16: item.totalNonVatValue || 0,
                17: 0,
                18: 0,
                19: 0,
                20: 0,
                21: 1,
                22: 0,
                23: 0,
                24: 0,
                25: 0,
                26: 1,
                27: 0,
                28: 0,
                29: 0,
                30: 0,
                31: 7,
                32: 0,
                33: 0,
                34: 0,
                35: 0,
                36: item.totalVatValue || 0,
                37: 0,
                38: 0,
                39: 0,
                40: 0,
                41: accountingProduct.tempCode || "",
                42: accountingProduct.tempCode2 || "",
                43: accountingProduct.tempCode3 || "",
                44: areaMeterName,
                45: 0,
                46: 0,
                51: 0,
                52: 0,
                54: 1,
                55: 1,
                56: 0,
                57: 0,
                58: 0,
                59: 0,
                61: 0,
                62: 0,
                63: 1,
                64: 0,
                65: 0,
                66: 0,
                67: 0,
                68: 0,
                69: 0,
                70: 0,
                71: 0,
                72: 0,
                73: 0,
                74: 0,
                75: 0,
                76: 0,
                77: 0,
                78: 0,
                79: 0,
                80: 0,
                81: 0,
                82: 0,
                83: 0,
                84: 0,
                85: 0,
                86: 0,
                87: 0,
                88: 0,
                89: 0,
                90: 0,
                91: 0,
                92: 0,
                93: 0,
                94: 0,
                95: 0,
                96: 0,
                97: 0,
                98: 0,
                99: 0,
                100: 0,
                101: 0,
                102: 0,
                103: 0,
                104: 0,
                105: 0,
                106: item.totalValue || 0,
                107: 0,
                108: 0,
                109: 0,
                110: 0,
                111: 0,
                112: 0,
                113: 0,
                114: 0,
                115: 0,
                116: 0,
                117: 0,
              });
              worksheet.addRow({
                1: 5,
                2: "18497",
                3: index,
                4: 20,
                5: "COSTCENTER",
                6: buCode || "",
                7: 1,
                8: 60,
                9: 0,
                10: 0,
                11: 0,
                12: 1,
                13: 21,
                14: buCode || "",
                15: 0,
                16: 0,
                17: 0,
                18: 0,
                20: "00:00:00",
                21: "หน่วยต้นทุน"
              });
            }

            worksheet.addRow({
              1: 3,
              2: "18497",
              3: index,
              4: 1,
              5: moment(invoice.dueDate).format("YYYYMMDD"),
              6: total.totalValue || 0,
              8: 0,
              9: total.totalValue || 0,
              10: 0,
            });
            worksheet.addRow({
              1: 4,
              2: "18497",
              3: index,
              4: "COSTCENTER",
              5: "0000000",
              6: 1,
              7: 60,
              8: 0,
              9: 0,
              10: -1,
              11: 1,
              12: 21,
              13: 0,
              14: 0,
              15: 0,
              16: 0,
              17: 0,
              19: "00:00:00",
              20: "หน่วยต้นทุน"
            });

          }
        }
      }
    }

    if (callBackType == "buffer") {
      // Thai Windows Char set
      let buf = await workbook.csv.writeBuffer();
      return iconv.encode(buf.toString("utf8") + "\n", 'win874');

      // UTF-8 Char set
      // return workbook.csv.writeBuffer()
    } else {
      // Thai Windows Char set
      let buf = await workbook.csv.writeBuffer();
      let win874Buf = iconv.encode(buf.toString("utf8") + "\n", 'win874');

      const blob = new Blob([win874Buf], { type: "text/csv" });
      return saveAs(blob, "sage-invoice-" + moment().format("DDMMYY") + ".csv");
    }
  }

  static async exportCustomer(contracts, callBackType) {
    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet("INV")
    worksheet.columns = Array(154).fill({}).map((data, index) => {
      return {
        key: index + 1,
        width: 13
      }
    });
    worksheet.addRow({
      1: "RECTYPE",
      2: "IDCUST",
      3: "TEXTSNAM",
      4: "IDGRP",
      5: "IDNATACCT",
      6: "SWACTV",
      7: "DATEINAC",
      8: "DATELASTMN",
      9: "SWHOLD",
      10: "DATESTART",
      11: "CODEDAB",
      12: "CODEDABRTG",
      13: "DATEDAB",
      14: "NAMECUST",
      15: "TEXTSTRE1",
      16: "TEXTSTRE2",
      17: "TEXTSTRE3",
      18: "TEXTSTRE4",
      19: "NAMECITY",
      20: "CODESTTE",
      21: "CODEPSTL",
      22: "CODECTRY",
      23: "NAMECTAC",
      24: "TEXTPHON1",
      25: "TEXTPHON2",
      26: "CODETERR",
      27: "IDACCTSET",
      28: "IDAUTOCASH",
      29: "IDBILLCYCL",
      30: "IDSVCCHRG",
      31: "CODECURN",
      32: "SWPRTSTMT",
      33: "SWBALFWD",
      34: "CODETERM",
      35: "IDRATETYPE",
      36: "CODETAXGRP",
      37: "IDTAXREGI1",
      38: "IDTAXREGI2",
      39: "IDTAXREGI3",
      40: "IDTAXREGI4",
      41: "IDTAXREGI5",
      42: "TAXSTTS1",
      43: "TAXSTTS2",
      44: "TAXSTTS3",
      45: "TAXSTTS4",
      46: "TAXSTTS5",
      47: "AMTCRLIMT",
      48: "AMTBALDUET",
      49: "AMTBALDUEH",
      50: "DATELASTST",
      51: "AMTLASTSTT",
      52: "DTBEGBALFW",
      53: "AMTBALFWDT",
      54: "DTLASTRVAL",
      55: "AMTBALLARV",
      56: "CNTOPENINV",
      57: "CNTINVPAID",
      58: "DAYSTOPAY",
      59: "DATEINVCHI",
      60: "DATEBALHI",
      61: "DATEINVHIL",
      62: "DATEBALHIL",
      63: "DATELASTAC",
      64: "DATELASTIV",
      65: "DATELASTCR",
      66: "DATELASTDR",
      67: "DATELASTPA",
      68: "DATELASTDI",
      69: "DATELASTAD",
      70: "DATELASTWR",
      71: "DATELASTRI",
      72: "DATELASTIN",
      73: "IDINVCHI",
      74: "IDINVCHILY",
      75: "AMTINVHIT",
      76: "AMTBALHIT",
      77: "AMTINVHILT",
      78: "AMTBALHILT",
      79: "AMTLASTIVT",
      80: "AMTLASTCRT",
      81: "AMTLASTDRT",
      82: "AMTLASTPYT",
      83: "AMTLASTDIT",
      84: "AMTLASTADT",
      85: "AMTLASTWRT",
      86: "AMTLASTRIT",
      87: "AMTLASTINT",
      88: "AMTINVHIH",
      89: "AMTBALHIH",
      90: "AMTINVHILH",
      91: "AMTBALHILH",
      92: "AMTLASTIVH",
      93: "AMTLASTCRH",
      94: "AMTLASTDRH",
      95: "AMTLASTPYH",
      96: "AMTLASTDIH",
      97: "AMTLASTADH",
      98: "AMTLASTWRH",
      99: "AMTLASTRIH",
      100: "AMTLASTINH",
      101: "CODESLSP1",
      102: "CODESLSP2",
      103: "CODESLSP3",
      104: "CODESLSP4",
      105: "CODESLSP5",
      106: "PCTSASPLT1",
      107: "PCTSASPLT2",
      108: "PCTSASPLT3",
      109: "PCTSASPLT4",
      110: "PCTSASPLT5",
      111: "AVGDAYSPAY",
      112: "PRICLIST",
      113: "CUSTTYPE",
      114: "AMTPDUE",
      115: "EMAIL1",
      116: "EMAIL2",
      117: "WEBSITE",
      118: "BILLMETHOD",
      119: "PAYMCODE",
      120: "FOB",
      121: "SHPVIACODE",
      122: "SHPVIADESC",
      123: "DELMETHOD",
      124: "PRIMSHIPTO",
      125: "CTACPHONE",
      126: "CTACFAX",
      127: "SWPARTSHIP",
      128: "SWWEBSHOP",
      129: "RTGPERCENT",
      130: "RTGDAYS",
      131: "RTGTERMS",
      132: "RTGAMTTC",
      133: "RTGAMTHC",
      134: "VALUES",
      135: "PROCESSCMD",
      136: "CNTPPDINVC",
      137: "AMTPPDINVT",
      138: "AMTPPDINVH",
      139: "DATELASTRF",
      140: "AMTLASTRFT",
      141: "AMTLASTRFH",
      142: "CODECHECK",
      143: "NEXTCUID",
      144: "LOCATION",
      145: "SWCHKLIMIT",
      146: "SWCHKOVER",
      147: "OVERDAYS",
      148: "OVERAMT",
      149: "SWBACKORDR",
      150: "SWCHKDUPPO",
      151: "EWSUPPRESS",
      152: "EWARVER",
      153: "EWORGID",
      154: "EWMODE",
    });
    worksheet.addRow({
      1: "RECTYPE",
      2: "IDCUST",
      3: "OPTFIELD",
      4: "VALUE",
      5: "TYPE",
      6: "LENGTH",
      7: "DECIMALS",
      8: "ALLOWNULL",
      9: "VALIDATE",
      10: "SWSET",
      11: "VALINDEX",
      12: "VALIFTEXT",
      13: "VALIFMONEY",
      14: "VALIFNUM",
      15: "VALIFLONG",
      16: "VALIFBOOL",
      17: "VALIFDATE",
      18: "VALIFTIME",
      19: "FDESC",
      20: "VDESC",
    })
    for (let contract of contracts) {
      let startDate = moment(contract.startDate.iso).format("YYYYMMDD")

      let customer = contract.customer || {}
      let citizenCardIssueDate = customer.citizenCardIssueDate ? `${moment(customer.citizenCardIssueDate).format("D/MM")}/${moment(customer.citizenCardIssueDate).year() + 543}` : ""
      let citizenCardExpiryDate = customer.citizenCardExpiryDate ? `${moment(customer.citizenCardExpiryDate).format("D/MM")}/${moment(customer.citizenCardExpiryDate).year() + 543}` : ""
      let dateOfBirth = customer.dateOfBirth ? `${moment(customer.dateOfBirth).year() + 543}${moment(customer.dateOfBirth).format("MMDD")}` : ""
      let market = contract.market

      worksheet.addRow({
        1: 1,
        2: contract.customerMarketId || "",
        3: customer.fullName || "",
        4: "MAK",
        6: 1,
        8: startDate, // "(no data)"
        9: 0,
        10: startDate,
        14: customer.fullName || "",
        15: customer.fullAddress || "",
        // 18: contract.billingData.taxId ? "เลขที่ประจำตัวผู้เสียภาษี" : "",
        // 19: contract.billingData.taxId || "",
        24: customer.tels.filter(d => { return d }).join(",") || "",
        27: "MAK",
        29: "BILLMT",
        30: "INTRL",
        31: "THB",
        32: 0,
        33: 0,
        34: "N0",
        35: "SP",
        36: "TAX0",
        42: 1,
        43: 0,
        44: 0,
        45: 0,
        46: 0,
        47: 0,
        48: 0,
        49: 0,
        51: 0,
        53: 0,
        55: 0,
        56: 0,
        57: 1,
        58: 0,
        // 59: startDate + "(no data)",
        // 63: startDate + "(no data)",
        // 64: startDate + "(no data)",
        // 67: startDate + "(no data)",
        // 73: "IN0000095773" + "(no data)",
        75: 0, // 600 + "(no data)",
        76: 0,
        77: 0,
        78: 0,
        79: 0, // 600 + "(no data)",
        80: 0,
        81: 0,
        82: 0, // -600 + "(no data)",
        83: 0,
        84: 0,
        85: 0,
        86: 0,
        87: 0,
        88: 0, // 600 + "(no data)",
        89: 0,
        90: 0,
        91: 0,
        92: 0, // 600 + "(no data)",
        93: 0,
        94: 0,
        95: 0, // -600 + "(no data)",
        96: 0,
        97: 0,
        98: 0,
        99: 0,
        100: 0,
        106: 0,
        107: 0,
        108: 0,
        109: 0,
        110: 0,
        111: 0,
        113: 0,
        114: 0,
        118: 0,
        123: 0,
        127: 1,
        128: 0,
        129: 0,
        130: 0,
        132: 0,
        133: 0,
        134: 5,
        135: 0,
        136: 0,
        137: 0,
        138: 0,
        140: 0,
        141: 0,
        142: "ENG",
        143: 1,
        145: 1,
        146: 0,
        147: 0,
        148: 0,
        149: 1,
        150: 0,
        151: 0,
        152: "61A",
        153: market && (market.companyCode == "TTLPF" || market.companyCode == "CSL") ? "TTLC17" : market && market.companyCode == "TAECO" ? "THACOM" : "",
        154: 0
      })
      worksheet.addRow({
        1: 2,
        2: contract.customerMarketId || "",
        3: "CUS3",
        4: customer.title || "",
        5: 1,
        6: 4,
        7: 0,
        8: 0,
        9: 0,
        10: 1,
        11: 21,
        12: customer.title || "",
        13: 0,
        14: 0,
        15: 0,
        16: 0,
        18: "0:00:00",
        19: "คำนำหน้า",
      })
      worksheet.addRow({
        1: 2,
        2: contract.customerMarketId || "",
        3: "CUS4",
        4: citizenCardIssueDate || "",
        5: 1,
        6: 12,
        7: 0,
        8: 0,
        9: 0,
        10: 1,
        11: 21,
        12: citizenCardIssueDate || "",
        13: 0,
        14: 0,
        15: 0,
        16: 0,
        18: "0:00:00",
        19: "วันออกบัตร",
      })
      worksheet.addRow({
        1: 2,
        2: contract.customerMarketId || "",
        3: "CUS5",
        4: citizenCardExpiryDate || "",
        5: 1,
        6: 15,
        7: 0,
        8: 0,
        9: 0,
        10: 1,
        11: 21,
        12: citizenCardExpiryDate || "",
        13: 0,
        14: 0,
        15: 0,
        16: 0,
        18: "0:00:00",
        19: "วันหมดอายุ",
      })
      worksheet.addRow({
        1: 2,
        2: contract.customerMarketId || "",
        3: "CUS6",
        4: dateOfBirth || "",
        5: 3,
        6: 0,
        7: 0,
        8: 0,
        9: 0,
        10: 1,
        11: 26,
        12: dateOfBirth || "",
        13: 0,
        14: 0,
        15: 0,
        16: 0,
        18: "0:00:00",
        19: "วันเกิด",
      })
      worksheet.addRow({
        1: 2,
        2: contract.customerMarketId || "",
        3: "IDCARD",
        5: 1,
        4: customer.citizenId || "",
        6: 30,
        7: 0,
        8: 0,
        9: 0,
        10: 1,
        11: 21,
        12: customer.citizenId || "",
        13: 0,
        14: 0,
        15: 0,
        16: 0,
        18: "0:00:00",
        19: "ID CARD",
      })
    }

    if (callBackType == "buffer") {
      // Thai Windows Char set
      let buf = await workbook.csv.writeBuffer();
      return iconv.encode(buf.toString("utf8") + "\n", 'win874');

      // UTF-8 Char set
      // return workbook.csv.writeBuffer()
    } else {
      // Thai Windows Char set
      let buf = await workbook.csv.writeBuffer();
      let win874Buf = iconv.encode(buf.toString("utf8") + "\n", 'win874');

      const blob = new Blob([win874Buf], { type: "text/csv" });
      return saveAs(blob, "sage-customer-" + moment().format("DDMMYY") + ".csv");
    }
  }

  static async exportInvoiceZip(invoices, contracts) {
    let invoiceFile = await ExportSAGE.exportInvoice(invoices, "buffer")
    let customerFile = await ExportSAGE.exportCustomer(contracts, "buffer")
    // let recurringInvoiceFile = await ExportSAGE.exportInvoice(market, recurringInvoices, hashArea, hashAccountingProduct, "buffer")

    const zip = new JSZip();
    zip.file("sage-invoice-" + moment().format("YYYYMMDD") + ".csv", invoiceFile);
    zip.file("sage-customer-" + moment().format("YYYYMMDD") + ".csv", customerFile);
    // zip.file("sage-recurring-invoice-" + moment().format("DD-MM-YYYY") + ".csv", recurringInvoiceFile);
    let blob = await zip.generateAsync({ type: "blob" })

    return saveAs(blob, "sage-invoice-" + moment().format("YYYYMMDD"));
  }

  static async exportReceiptZip(receipts) {
    const zip = new JSZip();
    let fileName = {
      1: "cash",
      2: "transfer",
      3: "credit",
      4: "billpay",
      5: "deposit",
      6: "cheque",
    }
    for (let companyCode of ["TTLPF", "TAECO", "CSL"]) {
      let receiptsByCompanyCode = receipts.filter(d => d.market && d.market.companyCode == companyCode)
      for (let paymentMethod of [1, 2, 3, 4, 5, 6]) {
        let _receipts = receiptsByCompanyCode.filter(d => d.paymentMethod == paymentMethod)
        if (paymentMethod == 1 || paymentMethod == 3) {
          if (_receipts.length) {
            if (companyCode == "TTLPF") {
              let file = await ExportSAGE.exportReceipt(_receipts, "UOBSA1", "buffer")
              zip.file(`${companyCode}-${fileName[paymentMethod]}-UOBSA1-${moment().format("YYYYMMDD")}.csv`, file);
            }
            if (companyCode == "TAECO") {
              let file = await ExportSAGE.exportReceipt(_receipts, "UOBSA", "buffer")
              zip.file(`${companyCode}-${fileName[paymentMethod]}-UOBSA-${moment().format("YYYYMMDD")}.csv`, file)
            }
            if (companyCode == "CSL") {
              let file = await ExportSAGE.exportReceipt(_receipts, "CASHTR", "buffer")
              zip.file(`${companyCode}-${fileName[paymentMethod]}-CASHTR-${moment().format("YYYYMMDD")}.csv`, file)
            }
          }
        } else if (paymentMethod == 5) {
          if (_receipts.length) {
            let file = await ExportSAGE.exportReceipt(_receipts, "APINV", "buffer")
            zip.file(`${companyCode}-${fileName[paymentMethod]}-APINV-${moment().format("YYYYMMDD")}.csv`, file);
          }
        } else {
          let receiptsHasBankAccount = _receipts.filter(d => d.paymentBankAccount && d.paymentBankAccount.erpCode)
          let erpCodes = new Set(receiptsHasBankAccount.map(d => d.paymentBankAccount.erpCode))
          for (let erpCode of erpCodes) {
            let dataset = receiptsHasBankAccount.filter(d => d.paymentBankAccount.erpCode == erpCode)
            if (dataset.length) {
              let file = await ExportSAGE.exportReceipt(dataset, erpCode, "buffer")
              zip.file(`${companyCode}-${fileName[paymentMethod]}-${erpCode}-${moment().format("YYYYMMDD")}.csv`, file);
            }
          }
          let receiptsInvalidErpCode = _receipts.filter(d => d.paymentBankAccount && !d.paymentBankAccount.erpCode)
          if (receiptsInvalidErpCode.length) {
            let file = await ExportSAGE.exportReceipt(receiptsInvalidErpCode, "", "buffer")
            zip.file(`${companyCode}-${fileName[paymentMethod]}-invalid-${moment().format("YYYYMMDD")}.csv`, file);
          }
        }
      }
    }
    let blob = await zip.generateAsync({ type: "blob" })
    return saveAs(blob, "sage-receipt-" + moment().format("YYYYMMDD"));
  }
}

const saveFile = async (workbook, fileName) => {
  const buffer = await workbook.xlsx.writeBuffer();
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  const fileExtension = '.xlsx';
  const blob = new Blob([buffer], { type: fileType });
  return saveAs(blob, fileName + fileExtension);
}
